import React from 'react';
import { styled, StyledProps } from '@glitz/react';

type ConnectedPropType = {
  label: string;
  isCompact: boolean;
};

type PropType = StyledProps & ConnectedPropType;

const Wrap = styled.div({
  alignSelf: 'end',     
  display: 'flex',
  whiteSpace: 'nowrap',
})

const Heading = styled.h2({
  display: 'block',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '100%',
  textTransform: 'uppercase',
  margin: { xy: 0 },
})

class RotatedHeader extends React.Component<PropType> {
  render() {
    const { label, isCompact } = this.props;

    return (
      <Wrap>
        <Heading 
          css={{
            transform: 'rotate(180deg)',
            writingMode: 'vertical-rl',
        }}>
          {label}
        </Heading>
      </Wrap>
    );
  }
}

export default styled(RotatedHeader);
